import { Bar, Eyebrow, Ring, Screen, Title } from '../components/ui';
import { TOPICS } from '../content/topics';
import { topicPercent } from '../store/state';
import { useApp, useStartSet } from '../store/useApp';

export function Topics() {
  const { state } = useApp();
  const startSet = useStartSet();
  const { progress, settings } = state;

  return (
    <Screen>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Title>Topics</Title>
        <div style={{ font: '400 13px/1.4 var(--font-body)', color: 'var(--text-4)' }}>
          {TOPICS.length} things. Any order.
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {TOPICS.map((topic) => {
          const pct = topicPercent(progress, topic.id, settings.setLength);
          const locked = topic.prereqs.filter((p) => (progress.best[p] ?? 0) === 0);

          return (
            <button
              key={topic.id}
              type="button"
              onClick={() => startSet(topic.id)}
              style={{
                display: 'block',
                width: '100%',
                padding: '15px 16px',
                borderRadius: 15,
                background: 'var(--surface)',
                border: '1px solid var(--line)',
                cursor: 'pointer',
                color: 'var(--text)',
                textAlign: 'left',
              }}
            >
              <div
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  <div style={{ font: '700 16px/1.15 var(--font-display)' }}>{topic.name}</div>
                  <div
                    style={{
                      font: '400 12.5px/1.35 var(--font-body)',
                      color: 'var(--text-4)',
                      textWrap: 'pretty',
                    }}
                  >
                    {topic.blurb}
                  </div>
                </div>
                <Ring pct={pct} />
              </div>

              {/* Prerequisites are a hint, never a lock. Nothing in this app
                  stops her opening a topic she wants to look at today. */}
              {locked.length > 0 && pct === 0 && (
                <div style={{ marginTop: 10 }}>
                  <Eyebrow tone="var(--text-4)">
                    Easier after {locked.map((id) => TOPICS.find((t) => t.id === id)?.name).join(' and ')}
                  </Eyebrow>
                </div>
              )}

              <div style={{ marginTop: 12 }}>
                <Bar pct={pct} />
              </div>
            </button>
          );
        })}
      </div>
    </Screen>
  );
}
